import { Link } from '@trashlab/sitesapp/src/organizations/redebins/components/shared/link';

interface ServiceAreaItem {
  name: string;
  slug?: string; // If provided, the item becomes a link
}

interface ServiceAreaGroup {
  items: ServiceAreaItem[];
}

const SERVICE_AREAS: ServiceAreaGroup[] = [
  {
    items: [
      { name: 'Anoka County' },
      {
        name: 'St. Paul',
        slug: '/service-areas/dumpster-rental-st-paul-mn',
      },
    ],
  },
  {
    items: [{ name: 'Carver' }, { name: 'Scott' }],
  },
  {
    items: [{ name: 'Dakota' }, { name: 'Washington' }],
  },
  {
    items: [
      {
        name: 'Minneapolis',
        slug: '/service-areas/dumpster-rental-minneapolis-mn',
      },
      {
        name: 'St. Louis Park',
        slug: '/service-areas/dumpster-rental-st-louis-park-mn',
      },
    ],
  },
];

export const ServiceAreasSection = () => {
  return (
    <section className="py-16 bg-[#444444]">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-10 text-center">
            Currently Serving Greater Minneapolis & St. Paul
          </h2>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {SERVICE_AREAS.map((group, groupIndex) => (
              <ul key={groupIndex} className="space-y-2 list-disc list-inside">
                {group.items.map((item, itemIndex) => (
                  <li
                    key={itemIndex}
                    className="text-white text-sm md:text-base marker:text-white"
                  >
                    {item.slug ? (
                      <Link
                        href={item.slug}
                        className="hover:underline transition-colors"
                      >
                        {item.name}
                      </Link>
                    ) : (
                      item.name
                    )}
                  </li>
                ))}
              </ul>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
